import { LocationDirection, Side } from "../../models/Common"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "../Base"

export class SensorLayer extends BaseComponent {
  public constructor(
    thickness: number,
    sensorId: number,
    centralOffsetX: number,
    centralOffsetY: number,
    sensorW: number
  ) {
    super(
      {
        id: sensorId,
        color: "#00ccff",
        description: "",
      } as IComponentInfo,
      {
        width: sensorW,
        height: thickness,
        centralOffsetX: centralOffsetX,
        centralOffsetY: centralOffsetY + thickness / 2,
      } as IComponentShape,
      {
        dimensions: {
          sides: [Side.Right],
          diff: true,
        },
        id: {
          locationDirection: LocationDirection.Outward,
          fromSide: Side.Left,
          padding: 40,
        },
        description: false,
      } as IComponentLabels
    )
  }
}
